(function(){
     'use strict';

     angular
        .module('app')
        .factory('RedirectService', RedirectService);

    RedirectService.$inject = ['$http'];

    function RedirectService($http){


        var service= {
            setRedirectAlias: setRedirectAlias,
            setRedirectSlug:setRedirectSlug
        };

        return service;

        function setRedirectAlias(data,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
            	urlOrigenAlias: data.urlOrigenAlias,
				urlDestinoAlias: data.urlDestinoAlias,
				tipo:"alias"
            });
            $http.post('/backend/altcrm/redirect/alias', data, config)
            .success(getRedirectSuccess)
            .error(getRedirectFailed);
            function getRedirectSuccess(data){ 
                callback(data);
            }
            function getRedirectFailed(data){
                return false;
            }
        }

        function setRedirectSlug(data,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            var data = $.param({
            	urlOrigenAlias: data.urlOrigenSlug,
				urlDestinoAlias: data.urlDestinoSlug,
				tipo:"slug"
            });
            $http.post('/backend/altcrm/redirect/alias', data, config)
            .success(getRedirectSuccess)
            .error(getRedirectFailed);
            function getRedirectSuccess(data){ 
                callback(data);
            }
            function getRedirectFailed(data){
                return false;
            }
        }
        
    }
})();